import { type WorkplaceTypesResponse, type WorkplaceTypeWithQualifications } from "../types";

export function getWorkplaceTypesWithQualifications(
  workplaceTypesResponse: WorkplaceTypesResponse
): WorkplaceTypeWithQualifications[] {
  const qualificationLookup = new Map(
    workplaceTypesResponse.included.map((qualification) => [qualification.id, qualification])
  );

  return workplaceTypesResponse.data.map((workplaceType) => {
    const qualifications = workplaceType.relationships.qualifications.data.map((ref) => {
      const qualification = qualificationLookup.get(ref.id);
      if (!qualification) {
        throw new Error(`missing qualification: ${ref.id}`);
      }

      return qualification;
    });

    return { ...workplaceType, qualifications };
  });
}
